document.documentElement.classList.remove('no-js');

const initializeTheme = () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gallery-src]');
    if (!button) return;

    const main = document.querySelector('[data-gallery-main]');
    const label = document.querySelector('[data-gallery-label]');
    if (!main) return;
    main.src = button.dataset.gallerySrc;
    main.alt = button.dataset.galleryAlt || '';
    if (label) label.textContent = button.dataset.galleryLabelText || '';
    document.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  });

  document.querySelectorAll('[data-delivery-timeline]').forEach((timeline) => {
    const locale = document.documentElement.lang || 'en-US';
    const today = new Date();
    const orderDate = timeline.querySelector('[data-order-date]');
    const shortDate = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
    if (orderDate) orderDate.textContent = shortDate.format(today);
    requestAnimationFrame(() => timeline.classList.add('is-ready'));
  });

  const sticky = document.querySelector('[data-sticky-atc]');
  const productForm = document.querySelector('#ProductForm');
  if (sticky && productForm) {
    const offerOptions = productForm.querySelectorAll('[data-offer-option]');
    const handFieldset = productForm.querySelector('[data-hand-fieldset]');
    const addToCart = productForm.querySelector('[data-add-to-cart]');
    const pairConfig = productForm.querySelector('[data-pair-config]');
    const formStatus = productForm.querySelector('[data-product-form-status]');
    const viewBag = productForm.querySelector('[data-view-bag]');
    const productExpress = productForm.querySelector('[data-product-express]');
    const bundleExpress = document.querySelector('[data-bundle-express]');
    const mainPrice = document.querySelector('.pdp-buybox .product-price');
    const initialMainPrice = mainPrice ? mainPrice.innerHTML : '';

    const selectedOffer = () => productForm.querySelector('[data-offer-option]:checked')?.value || 'single';
    const selectedVariant = () => productForm.querySelector('[data-variant-option]:checked');

    const syncOffer = () => {
      const pairSelected = selectedOffer() === 'pair';
      const variant = selectedVariant();
      const checkoutVariant = productForm.querySelector('[data-checkout-variant]');
      if (checkoutVariant && variant && checkoutVariant.value !== variant.value) {
        checkoutVariant.value = variant.value;
        checkoutVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const pairOption = productForm.querySelector('[data-offer-option][value="pair"]');
      const displayedPrice = pairSelected ? pairOption?.dataset.pairPrice : variant?.dataset.price;

      if (handFieldset) handFieldset.hidden = pairSelected;
      if (productExpress) productExpress.hidden = pairSelected && pairConfig?.dataset.productIsBundle !== 'true';
      if (bundleExpress) bundleExpress.hidden = !pairSelected;
      if (addToCart) {
        const label = pairSelected ? addToCart.dataset.pairLabel : addToCart.dataset.singleLabel;
        addToCart.textContent = displayedPrice ? `${label} · ${displayedPrice}` : label;
      }
      if (mainPrice) {
        mainPrice.innerHTML = pairSelected && displayedPrice
          ? `${displayedPrice} <span>${window.Shopify?.currency?.active || 'USD'}</span>`
          : initialMainPrice;
      }
      const stickyPrice = sticky.querySelector('[data-sticky-price]');
      if (stickyPrice && displayedPrice) stickyPrice.textContent = displayedPrice;
      const stickySelection = sticky.querySelector('[data-sticky-selection]');
      if (stickySelection) {
        const singleLabel = sticky.dataset.singleLabel;
        const pairLabel = sticky.dataset.pairLabel;
        stickySelection.textContent = pairSelected
          ? pairLabel
          : `${singleLabel} · ${variant?.dataset.handLabel || ''}`;
      }
      const stickySubmitLabel = sticky.querySelector('[data-sticky-submit-label]');
      const stickySubmit = sticky.querySelector('[data-sticky-submit]');
      const stickyVariant = sticky.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.value = pairSelected ? pairConfig.dataset.bundleVariantId : (variant?.value || productForm.querySelector('input[name="id"]')?.value);
      if (stickySubmitLabel && stickySubmit) {
        stickySubmit.disabled = pairSelected ? pairConfig.dataset.pairCheckoutReady !== 'true' : Boolean(variant?.disabled || !productForm.querySelector('input[name="id"]')?.value);
        stickySubmitLabel.textContent = stickySubmit.dataset.buyLabel;
      }
      if (formStatus) formStatus.textContent = '';
    };

    offerOptions.forEach((option) => option.addEventListener('change', syncOffer));

    productForm.addEventListener('submit', async (event) => {
      if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      if (!pairConfig || !addToCart) return;
      if (productForm.classList.contains('is-loading')) return;
      const pairSelected = selectedOffer() === 'pair';

      if (pairSelected && pairConfig.dataset.pairCheckoutReady !== 'true') {
        if (formStatus) formStatus.textContent = pairConfig.dataset.pairPendingLabel;
        return;
      }

      const variantId = pairSelected
        ? Number(pairConfig.dataset.bundleVariantId)
        : Number(selectedVariant()?.value || productForm.querySelector('input[name="id"]')?.value);
      if (!variantId) return;

      productForm.classList.add('is-loading');
      addToCart.disabled = true;
      addToCart.textContent = addToCart.dataset.addingPairLabel;
      if (formStatus) formStatus.textContent = '';

      try {
        const response = await fetch(pairConfig.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: variantId, quantity: 1 }
            ]
          })
        });
        if (!response.ok) throw new Error('Pair add failed');

        productForm.classList.remove('is-loading');
        addToCart.disabled = false;
        syncOffer();
        if (formStatus) formStatus.textContent = pairConfig.dataset.addedLabel;
        if (viewBag) viewBag.hidden = false;
        const root = window.Shopify?.routes?.root || '/';
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : null)
          .then((cart) => {
          if (!cart) return;
          document.querySelectorAll(`a[href="${root}cart"]`).forEach((link) => {
            if (/^bag\s*\d+$/i.test(link.textContent.trim())) link.textContent = `${pairConfig.dataset.bagLabel} ${cart.item_count}`;
          });
          }).catch(() => {});
      } catch (error) {
        productForm.classList.remove('is-loading');
        addToCart.disabled = false;
        syncOffer();
        if (formStatus) formStatus.textContent = pairConfig.dataset.addErrorLabel;
      }
    });

    const stickyTrigger = addToCart || productForm;
    const footer = document.querySelector('footer');
    let stickyFrame;
    const updateSticky = () => {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(() => {
        const triggerRect = stickyTrigger.getBoundingClientRect();
        const footerTop = footer ? footer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
        const pastPrimaryAction = triggerRect.bottom <= 16;
        const beforeFooter = footerTop > window.innerHeight - 16;
        sticky.classList.toggle('is-visible', pastPrimaryAction && beforeFooter);
        stickyFrame = null;
      });
    };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);

    const submit = sticky.querySelector('[data-sticky-submit]');
    const stickyCheckout = sticky.querySelector('[data-sticky-checkout]');
    if (submit && stickyCheckout) stickyCheckout.addEventListener('submit', (event) => {
      if (stickyCheckout.dataset.submitting === 'true' || !sticky.querySelector('[data-sticky-variant]')?.value) {
        event.preventDefault();
        return;
      }
      stickyCheckout.dataset.submitting = 'true';
      submit.disabled = true;
      sticky.querySelector('[data-sticky-submit-label]').textContent = submit.dataset.loadingLabel;
    });
    window.addEventListener('pageshow', () => {
      if (stickyCheckout) delete stickyCheckout.dataset.submitting;
      syncOffer();
    });

    const variantOptions = productForm.querySelectorAll('[data-variant-option]');
    variantOptions.forEach((option) => option.addEventListener('change', syncOffer));

    syncOffer();
  }

  const reviewDialog = document.querySelector('[data-review-photo-dialog]');
  if (reviewDialog) {
    const dialogImage = reviewDialog.querySelector('[data-review-photo-dialog-image]');
    const dialogCaption = reviewDialog.querySelector('[data-review-photo-dialog-caption]');
    const closeButton = reviewDialog.querySelector('[data-review-photo-close]');
    let reviewPhotoTrigger;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-review-photo-open]');
      if (!trigger) return;
      reviewPhotoTrigger = trigger;
      if (dialogImage) {
        dialogImage.src = trigger.dataset.reviewPhotoSrc;
        dialogImage.alt = trigger.dataset.reviewPhotoAlt || '';
      }
      if (dialogCaption) dialogCaption.textContent = trigger.dataset.reviewPhotoCaption || '';
      reviewDialog.showModal();
      closeButton?.focus();
    });

    closeButton?.addEventListener('click', () => reviewDialog.close());
    reviewDialog.addEventListener('click', (event) => {
      const bounds = reviewDialog.getBoundingClientRect();
      const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (outside) reviewDialog.close();
    });
    reviewDialog.addEventListener('close', () => reviewPhotoTrigger?.focus());
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTheme, { once: true });
} else {
  initializeTheme();
}
